import React, { useState } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { FcGoogle } from 'react-icons/fc';
import { useLanguage } from '../Translations/LenguageContext';
import { useNavigate } from 'react-router-dom';
import Spinner from '../Components/Spinner';
import ErrorMessage from '../Components/ErrorMessage';

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const GoogleLogin = ({ type_enter }) => {
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()
    const { t } = useLanguage()
    const [error, setError] = useState(null);

    const loginWithFirebase = () => {
        const provider = new GoogleAuthProvider();

        signInWithPopup(auth, provider)
            .then((result) => {
                const user = result.user;
                const nameParts = user.displayName.split(' ');
                const firstName = nameParts[0];
                const lastName = nameParts.slice(1).join(' ');
                check_email(user.email, firstName, lastName, user.photoURL);
            })
            .catch((error) => {
                console.error("Login error:", error);
                setError("Login failed. Please try again.");
            });
    };

    const check_email = (email, name, surname, picture) => {
        setLoading(true)
        fetch(`${GEN_BACKEND_LINK}/google_login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, name, surname, picture }),
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false)
                if (data.message === "OK") {
                    const account_id = data.account_id;
                    document.cookie = `account_id=${account_id}; path=/; max-age=` + (7 * 24 * 60 * 60);
                    localStorage.setItem("account_id", account_id);
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

                    if (isMobile) {
                        navigate("/mobile_device");
                    } else {
                        if (data.email_verified) {
                            if (data.onboarding.completed) {
                                navigate("/console/organizations");
                            } else {
                                navigate(`/onboarding/welcome`);
                            }
                        } else {
                            navigate(`/verify-email?email=${email}`);
                        }
                    }
                } else if (data.error === "Invalid_email_or_password") {
                    setErr({ message: t.register_form.invalid_email_pass, display: true });
                } else if (data.error === "email_not_valid") {
                    setErr({ message: t.register_form.email_format, display: true });
                } else if (data.error === "account_not_exists") {
                    setErr({ message: "Account does not exist. Please register first.", display: true });
                } else if (data.error) {
                    setErr({ message: t.register_form.errors_back, display: true });
                }
            })
            .catch((error) => {
                setLoading(false)
            });
    };

    return (
        <>
            <button className="reg_auth_ext_btn" onClick={loginWithFirebase}>
                {loading ? (
                    <Spinner loading={loading} />
                ) : (
                    <>
                        <i><FcGoogle /></i> {type_enter == "Register" ? t.register_form.button_register : t.register_form.button_login} {t.register_form.with_google}
                    </>
                )
                }
            </button>
            <ErrorMessage err={err} />
        </>

    );
};

export default GoogleLogin;
